// @ts-nocheck
"use client";

import { useEffect, useState } from "react";
import { getUserGeo } from "../lib/api";
import CookieBanner from "../components/atoms/cookie-banner";
import { loadGTM } from "../lib/gtm";

const GoogleTagManager = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [california, setCalifornia] = useState(false);
  const [eu, setEu] = useState(false);
  const [CCPAOptOut, setCCPAOptOut] = useState(false);

  const handleConsentGivenInternal = () => {
    handleConsentGiven();
    setShowBanner(false);
  };

  useEffect(() => {
    const init = async () => {
      const storedConsent = JSON.parse(localStorage.getItem("cookie_consent") || "{}");
      // Default geoLocation to EU in case getUserGeo fails
      let geoLocation = { continent_code: "EU", region_code: "" };
      try {
        const fetchedGeo = await getUserGeo();
        if (fetchedGeo) geoLocation = fetchedGeo;
      } catch {
        //console.log("denied geoLocation, defaulting to EU");
      }

      const isEU = geoLocation.continent_code === "EU";
      const isCalifornia = geoLocation.region_code === "CA";
      setCalifornia(isCalifornia);
      setEu(isEU);

      const isConsentStored = "analytics" in storedConsent || "marketing" in storedConsent;
      const isCcpaOptOut =
        storedConsent.donotsell === true ||
        (typeof navigator !== "undefined" && navigator.globalPrivacyControl === true);
      setCCPAOptOut(isCcpaOptOut);
      const consent = {
        ad_storage:
          isCcpaOptOut
            ? "denied" // force deny for CCPA opt-out
            : typeof storedConsent.marketing === "boolean"
              ? storedConsent.marketing ? "granted" : "denied"
              : !isEU
                ? "granted"
                : "denied",

        analytics_storage:
          typeof storedConsent.analytics === "boolean"
            ? storedConsent.analytics ? "granted" : "denied"
            : !isEU
              ? "granted"
              : "denied",

        functionality_storage: "granted",
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "default_consent", consent });
      window.dataLayer.push({ event: "gtm.init_consent" });
      window.dataLayer.push({ event: "gtm.js" });

      if (!isConsentStored || isCcpaOptOut) {
        setShowBanner(true);
      }

      if (consent.analytics_storage === "granted" || consent.ad_storage === "granted") {
        loadGTM();
      } else {
        //console.log("[Blocked GTM Load] - Consent denied");
      }
    };

    init();
  }, []);


  return showBanner ? (
    <CookieBanner
      onConsentGiven={handleConsentGivenInternal}
      isCalifornia={california}
      isEU={eu}
      isCcpaOptOut={CCPAOptOut}
    />
  ) : null;
};

export const handleConsentGiven = () => {
  const storedConsent = JSON.parse(localStorage.getItem("cookie_consent") || "{}");

  const consent = {
    ad_storage: storedConsent.marketing ? "granted" : "denied",
    analytics_storage: storedConsent.analytics ? "granted" : "denied",
    functionality_storage: "granted",
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "default_consent", consent });
  window.dataLayer.push({ event: "gtm.init_consent" });
  window.dataLayer.push({ event: "gtm.js" });

  if (consent.analytics_storage === "granted" || consent.ad_storage === "granted") {
    loadGTM();
  }
};

export const saveAndAccept = (adsConsentManual, analyticsConsentManual, functionsConsentManual, handleConsentGiven, donotsell = false) => {
  const storedConsent = JSON.parse(localStorage.getItem("cookie_consent") || "{}");
  
  const staticAdsConsent = typeof adsConsentManual === "boolean" ? adsConsentManual : storedConsent?.marketing ?? false;
  const staticAnalyticsConsent = typeof analyticsConsentManual === "boolean" ? analyticsConsentManual : storedConsent?.analytics ?? false;
  const staticFunctionsConsent = typeof functionsConsentManual === "boolean" ? functionsConsentManual : storedConsent?.functionality ?? true;

  localStorage.setItem("cookie_consent", JSON.stringify({
    marketing: staticAdsConsent,
    analytics: staticAnalyticsConsent,
    functionality: staticFunctionsConsent,
    donotsell: storedConsent ? false : donotsell
  }));

  if (window.gtag) {
    window.gtag("consent", "update", {
      ad_storage: staticAdsConsent ? "granted" : "denied",
      analytics_storage: staticAnalyticsConsent ? "granted" : "denied",
      functionality_storage: staticFunctionsConsent ? "granted" : "denied",
    });

    if (staticAnalyticsConsent || staticAdsConsent || staticFunctionsConsent) {
      window.gtag("config", "G-Z66XJQ8BHQ");
    }
  }

  handleConsentGiven();
};

export const GTMNoScript = () => null;
export default GoogleTagManager;
